import React from "react";
import {
  GridToolbarContainer,
  GridToolbarQuickFilter,
  GridToolbarExport,
} from "@mui/x-data-grid";
import { Button, Box, Switch, FormControlLabel } from "@mui/material";

export default function CustomToolbar({
  showRetired,
  setShowRetired,
  handleAddMeter,
  isSubmitting,
  loading,
}) {
  return (
    <GridToolbarContainer
      sx={{ display: "flex", alignItems: "center", p: 2, gap: 1 }}
    >
      <GridToolbarQuickFilter
        sx={{ mr: "auto", width: 300 }}
        placeholder="Search meters..."
        variant="outlined"
      />
      <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
        <FormControlLabel
          control={
            <Switch
              checked={showRetired}
              onChange={(e) => setShowRetired(e.target.checked)}
              size="small"
            />
          }
          label="Show Retired"
        />
        <Button
          variant="contained"
          onClick={handleAddMeter}
          color="secondary"
          disabled={isSubmitting || loading}
        >
          Add Meter
        </Button>
        <GridToolbarExport
          slotProps={{
            button: {
              variant: "outlined",
              size: "medium",
            },
          }}
        />
      </Box>
    </GridToolbarContainer>
  );
}
